import { useState } from "react";
import { TRAActionBarButton } from "../../design/visual";
import m from "../../features/match/court/styles/matchLiveVisual.module.css";

/**
 * Shared referee Fault sheet — sport modules pass fault type lists.
 * Layout matches Arena referee footer (TRA tokens / mono labels).
 */
export default function RefereeFaultSheet({
  matchStatus,
  onFault,
  disabled = false,
  serveDisplay = null,
  faultTypes = [],
  testId = "referee-fault-extras",
  title = "Fault",
}) {
  const [open, setOpen] = useState(false);
  const canFault = matchStatus === "live" && !disabled && typeof onFault === "function";

  return (
    <div className="sport-ref-extras" data-testid={testId}>
      {serveDisplay ? (
        <p className={m.scoreMetaLine} style={{ marginBottom: 8 }} aria-live="polite">
          {serveDisplay}
        </p>
      ) : null}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <TRAActionBarButton
          onClick={() => setOpen((v) => !v)}
          disabled={!canFault}
          data-testid={`${testId}-toggle`}
        >
          {title}
        </TRAActionBarButton>
      </div>
      {open && canFault ? (
        <div
          role="dialog"
          aria-label="Call fault"
          style={{
            marginTop: 8,
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 8,
          }}
        >
          {faultTypes.map((f) => (
            <button
              key={f.id}
              type="button"
              style={{
                minHeight: 48,
                padding: "8px 10px",
                borderRadius: 12,
                border: "1px solid color-mix(in srgb, var(--tra-color-border) 90%, transparent)",
                background: "var(--tra-color-surface, #fff)",
                color: "var(--tra-color-text)",
                fontFamily: "var(--tra-font-family-mono, Geist Mono, monospace)",
                fontSize: 11,
                letterSpacing: "0.04em",
                textTransform: "uppercase",
              }}
              onClick={() => {
                onFault(f.id);
                setOpen(false);
              }}
            >
              {f.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
